import { Controller } from "stimulus"

export default class extends Controller {
  static get targets() {
    return ["mode", "valueContainer", "value", "valueLabel", "help"]
  }

  connect() {
    this.refresh()
  }

  change() {
    this.refresh()
  }

  refresh() {
    const language = (this.data.get("language") || "es")
        .toLowerCase()
        .split(/[-_]/)[0]

    const isEnglish = language === "en"

    const checkedInput = this.modeTargets.find((input) => input.checked)
    const selected = checkedInput ? checkedInput.value : null

    const requiresValue = selected === "fixed" || selected === "percentage"

    this.valueContainerTarget.classList.toggle("hidden", !requiresValue)
    this.valueTarget.required = requiresValue

    if (!requiresValue) {
      this.valueTarget.value = ""
      this.valueTarget.removeAttribute("max")
      this.helpTarget.textContent = ""
      return
    }

    if (selected === "fixed") {
      this.valueLabelTarget.textContent = isEnglish
          ? "Amount per employee"
          : "Cantidad por empleado"

      this.helpTarget.textContent = isEnglish
          ? "Use 0.00 if you do not want to withhold income tax."
          : "Use 0.00 si no desea retener contribución sobre ingresos."

      this.valueTarget.removeAttribute("max")
    } else {
      this.valueLabelTarget.textContent = isEnglish
          ? "Percentage per employee"
          : "Porcentaje por empleado"

      this.helpTarget.textContent = isEnglish
          ? "The percentage will be applied to each employee's taxable bonus."
          : "El porcentaje se aplicará al bono tributable de cada empleado."

      this.valueTarget.max = "100"
    }
  }
}